import gql from 'graphql-tag'

export const LOGIN_MUTATION = gql`mutation LoginMutation($email: String!, $password: String!) {
    loginUser(
        email: $email,
        password: $password
    ) {
        refreshToken,
        token,
        user {
          username
        },
        userType
    }
}`

export const SIGNUP_MUTATION = gql`mutation SignupMutation($username: String!, $email: String!, $password: String!) {
    createUser(
        username: $username,
        email: $email,
        password: $password
    ) {
        refreshToken,
        token,
        user {
            username
        },
        userType
    }
}`

export const ALL_USERS_QUERY = gql`query AllUsersQuery {
    users {
        id
        username
        email
    }
}`

export const USER_QUERY = gql`query UserQuery($id: Int!) {
    userById(id: $id) {
        id
        username
        email
    }
}`

export const ALL_PAPERS_QUERY = gql`query AllPapers {
    allPapers {
        edges {
          node {
            id
            title
            authors {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
          }
        }
      }
}`

export const PAPER_SEARCH_QUERY = gql`query PaperQuery(
  $title: String,
  $category:[String],
  $topic: [String],
  $year: Int,
  $region: [String],
  $language: [String]
) {
    allPapers(
      title: $title,
      category: $category,
      topic: $topic,
      year: $year,
      region: $region,
      language: $language
    ) {
        id
        mainTopics
        title
        category
        year
        tags {
          id
          name
        }
        sdgs
        region
        language
        available
        url
        document
        authors {
          id
          name
        }
      }
}`

export const PAPER_MUTATION = gql`mutation PaperMutation(
    $authors: [String],
    $topics: [String],
    $title: String!,
    $category: String!,
    $year: Int,
    $tags: [String],
    $sgds: [String],
    $region: String!,
    $language: String!,
    $availeble: Boolean,
    $url: String!,
    $document: [DocumentType]!
  ) {
  createPaper(
    authors: $authors,
    topics: $topics,
    title: $title,
    category: $category,
    year: $year,
    tags: $tags,
    sgds: $sgds,
    region: $region,
    language: $language,
    availeble: $availeble,
    url: $url,
    document: $document
  ) {
    paper {
      id
      mainTopics
      title
      category
      year
      tags {
          id
          name
      }
      sdgs
      region
      language
      available
      url
      document
      authors {
          id
          name
      }
    }
  }
}`

export const PAPER_DETAILS_QUERY = gql`query PaperQuery($id: Int!) {
    paper(id: $id) {
        id
        mainTopics
        title
        category
        year
        tags {
            id
            name
        }
        sdgs
        region
        language
        available
        url
        document
        authors {
            id
            name
        }
    }
}`

export const PAPER_SEARCH_COUNT_QUERY = gql`query SearchQuery(
    $title: String,
    $topics: [String],
    $year: Int,
    $categories: [String],
    $regions: [String],
    $languages: [String],
    $resultCount: Int,
    $createdAfter: DateTime
  ) {
    allQueries(
        title: $title,
        categories: $categories,
        topics: $topics,
        year: $year,
        regions: $regions,
        languages: $languages,
        resultCount: $resultCount,
        createdAfter: $createdAfter
      ) {
        title
        topics
        categories
        regions
        languages
        resultCount
    }
  }`



// WEBPACK FOOTER //
// ./src/graphql.js